import { useCallback, useRef } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { observer } from "mobx-react-lite";
import { StateService } from "../services/StateService";
import CountDown from './CountDown';
import backgroundImg from '../assets/hero-card.png';
import { Toast, ToastProps } from './Toast';
import LinearProgressBar from "./LinearProgressBar";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    timerCountBox: {
      width: "95%",
      borderRadius: "27px",
      background: `url(${backgroundImg}) no-repeat`,
      backgroundSize: "cover",
      padding: 40,
    },
    timerCount: {
      zIndex: 999,
    },
    joinText: {
      fontSize: 42,
      fontFamily: "Gilroy-Regular, sans-serif",
      borderBottom: "1px solid #645d69",
      paddingBottom: 35,
      fontWeight: 400,
      marginBottom: 30,
      color: "white",
    },
    leftImg: {
      width: 300,
      height: 400,
      borderRadius: 20,
      transform: "rotate(159deg)",
      marginTop: 70,
      marginLeft: 135,
    },
    rightImg: {
      width: 300,
      height: 350,
      borderRadius: 20,
      transform: "rotate(30deg)",
      marginTop: 70,
      marginLeft: "-138px",
    },
    blueButtonSection: {
      marginTop: 95,
    },
    blueButton: {
      maxWidth: 490,
      backgroundColor: "#4E37DE",
      textAlign: "center",
      color: "#fff",
      padding: "19px 44px",
      textDecoration: "none",
      fontSize: 29,
      fontWeight: 400,
      textTransform: "uppercase",
      borderRadius: 19,
      fontFamily: "Gilroy-Medium, sans-serif",
      "&:hover": {
        textDecoration: "none !important",
        backgroundColor: "#3f2cb6",
        color: "#fff",
        transition: "all .2s linear",
      },
    },
    thanksSection: {
      fontSize: 42,
      fontFamily: "Gilroy-Regular, sans-serif",
      fontWeight: 400,
      marginBottom: 30,
      color: "white",
    }
  })
);

interface HeroSectionProps {
  countDownDate?: Date;
  width?: string;
  state: StateService;
  leftCardImg: string;
  rightCardImg: string;
  title: string;
  isDone: boolean;
  isAuction: boolean;
}

export const HeroSection = observer((props: HeroSectionProps) => {
  const classes = useStyles();
  const { countDownDate, leftCardImg, rightCardImg, title } = props;
  const messageToast = useRef<ToastProps>(null);

  const login = useCallback(async (event) => {
    const [status, message] = await props.state.onClickLoginMeta(event);
    messageToast.current?.showMessage(message as string, status ? 'success' : 'error');
  }, [props.state]);

  const getProgress = (): number => {
    const availableSlots = props.state.bidStore.getAvailableSlots();
    const totalSlots = props.state.bidStore.getTotalSlots();
    if (availableSlots && totalSlots) {
      return (100 * props.state.bidStore.getAvailableSlots() / props.state.bidStore.getTotalSlots());
    }
    return 100;
  }

  return (
    <div className={classes.root}>
      <Toast ref={messageToast} />
      <Grid container spacing={0}>
        <Grid item xs={3}>
          <img className={classes.leftImg} src={leftCardImg} alt="" />
        </Grid>
        <Grid item xs={6} className={classes.timerCount}>
          <Paper elevation={0} className={classes.timerCountBox}>
            <Typography
              gutterBottom
              variant="h5"
              component="h2"
              className={classes.joinText}
            >
              {title}
            </Typography>
            {props.isDone ?
                <p className={classes.thanksSection}>Thanks to everyone who took part!</p>
                : (props.isAuction ?
                    <LinearProgressBar
                        progress={getProgress()}
                        title={`${props.state.bidStore.getAvailableSlots()} Slots`}/>
                    : <CountDown countDownDate={countDownDate}/>
            )
            }
          </Paper>
          <div className={classes.blueButtonSection}>
            {!props.state.authentication.getAuthStatus() && (
              <Link href="#" className={classes.blueButton} onClick={login}>
                Connect Wallet
              </Link>
            )}
          </div>
        </Grid>
        <Grid item xs={3}>
          <img className={classes.rightImg} src={rightCardImg} alt="" />
        </Grid>
      </Grid>
    </div>
  );
});
